import "bootstrap-icons/font/bootstrap-icons.css";
import Markdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
import React, { useState } from "react";
import { isString } from "../../../../types/typeGuards";
import { Message } from "../../../../types/types";
import styles from "./ThoughtMessage.module.scss";
import MarkdownTable from "./components/MarkdownTable";

interface ThoughtMessageProps {
  message: Message;
}

const ThoughtMessage: React.FC<ThoughtMessageProps> = ({ message }) => {
  const content = message?.content;
  const detail =
    typeof message.thoughtDetail === "string" && message.thoughtDetail.trim()
      ? message.thoughtDetail.trim()
      : "";

  const [open, setOpen] = useState(false);

  const isLoadingThought =
    isString(content) &&
    /(thinking|searching|exhaustive document search)/i.test(content);

  const markdownProps = {
    remarkPlugins: [remarkGfm],
    rehypePlugins: [rehypeRaw],
    components: {
      table(props: Record<string, unknown>) {
        return <MarkdownTable {...props} />;
      },
    },
  };

  if (!message || !isString(content)) return null;

  if (detail) {
    return (
      <div className={`d-flex flex-row gap-2 ${styles.step}`}>
        <div className={styles.container}>
          <div className={styles.result}>
            <button
              type="button"
              className={styles.toggle}
              onClick={() => setOpen((v) => !v)}
              aria-expanded={open}
            >
              <span
                className={`${styles.chevron} ${open ? styles.chevronOpen : ""}`}
                aria-hidden
              >
                <i className="bi bi-chevron-right" />
              </span>
              <span className={styles.label}>
                <Markdown {...markdownProps}>{content}</Markdown>
              </span>
            </button>
            {open && (
              <div className={styles.detail} role="region">
                <Markdown {...markdownProps}>{detail}</Markdown>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`d-flex  flex-row gap-2 ${styles.step}`}>
      <div className={`${styles.container}`}>
        <div
          className={`${styles.result} ${styles.resultRow} ${isLoadingThought ? styles.loading : ""}`}
        >
          <div className={styles.label}>
            <Markdown {...markdownProps}>{content}</Markdown>
          </div>
          {isLoadingThought && (
            <span className={styles.spinner} aria-hidden />
          )}
        </div>
      </div>
    </div>
  );
};

export default ThoughtMessage;
